// extracted by mini-css-extract-plugin
module.exports = {"stepContainer":"VerticalProgressStep_stepContainer__nTr01","stepDivider":"VerticalProgressStep_stepDivider__ilh7i"};